<template>
  <div>
    <div>
      <span class="has-text-default is-italic"> N° {{tiers.code}} </span> <br>
      <p class="has-text-weight-semibold">
        {{ tiers.nomCommercial }}
        <span v-if="typologie"> {{ typologie }} </span>
      </p>
    </div>
    <div class="mgt-10px">
      <span class="has-text-default is-italic">
        {{ $t('detailClient.popupFusionTiers.adressePostale') }}
      </span>
      <p class="has-text-weight-semibold">
        {{tiers.adressePostale.intitule1}}
        {{tiers.adressePostale.intitule2}}
        {{tiers.adressePostale.intitule3}}
        <br v-if="tiers.adressePostale.intitule1">
        {{tiers.adressePostale.adresse1}}
        {{tiers.adressePostale.adresse2}}
        {{tiers.adressePostale.adresse3}}
        <br v-if="tiers.adressePostale.adresse1">
        {{tiers.adressePostale.codePostal}}
        {{tiers.adressePostale.ville}}
        {{tiers.adressePostale.pays}}
      </p>
    </div>
  </div>
</template>

<script>
import {
  TYPOLOGIE_AUCUN,
  LISTE_TYPOLOGIE,
} from '@/configuration/tiers/tiersConf';

export default {
  name: 'TiersInfo',
  props: {
    tiers: {
      type: Object,
      required: true,
    },
  },
  computed: {
    typologie() {
      const typologie = LISTE_TYPOLOGIE.find((typo) => typo.code === this.tiers.typologie);
      if (typologie.code !== TYPOLOGIE_AUCUN) return ` (${this.$t(typologie.libelle)})`;
      return '';
    },
  },
};
</script>
